import React from 'react';
import { Container, Typography } from '@mui/material';

const Aviacao: React.FC = () => {
  return (
    <Container>
      <Typography variant="h4" gutterBottom>Aviação</Typography>
      <Typography variant="body1">A aviação é uma área fascinante que abrange...</Typography>
    </Container>
  );
};

export default Aviacao;
